import React, { useContext } from "react";
import { Grid, Paper, Typography, Button, Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Serviceslide from "./homeslide/Serviceslide";
import OurApi from "./homeslide/OurApi";
import GetStarted from "./homeslide/GetStarted";
import { LangContext } from "../../Context/Langcontext";
import useReactRouter from "use-react-router";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
  textplace: {
    position: "absolute",
    top: "15%",
    right: "2.5rem",
  },
  getstart: {
    marginTop: "1.5rem",
    padding: "0.5rem 3rem",
    fontSize: "1.2rem",
    fontWeight: 200,
    border: "3px solid #FFFFFF",
    color: "#FFFFFF",
    "&:hover": {
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  paper: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    boxShadow: "unset",
  },
  itemcenter: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // background:
    //   "linear-gradient(180deg, rgba(255,229,189,1) 0%, rgba(254,211,140,1) 25%, rgba(246,169,150,1) 70%, rgba(239,135,159,1) 91%)",
  },
  maintext: {
    fontWeight: 700,
    color: "#ffffff",
    maxWidth: 320,
    fontSize: "4rem",
    lineHeight: 1.25,
  },
  itemtext: {
    height: "100%",
    width: "97%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    textAlign: "right",
  },
  secondtext: {
    fontWeight: 200,
    color: "#ffffff",
    maxWidth: 320,
    fontSize: "1.2rem",
  },
  appbar: {
    position: "static",
    width: "100%",
    height: "5rem",
  },
  imgstyle: {
    width: "70%",
    height: "auto",
  },
}));

const Home = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();

  return (
    <div>
      <div className={classes.appbar} />
      <Grid container spacing={0} className={classes.root}>
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
          }}
        >
          <Paper className={classes.paper}>
            <div className={classes.itemcenter}>
              <div
                style={{
                  height: "auto",
                  width: "100%",
                  position: "absolute",
                }}
              >
                <div
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-center"
                  data-aos-duration="2000"
                  className={classes.itemtext}
                >
                  <Typography className={classes.maintext}>
                    MEA MAP API
                  </Typography>
                  <Hidden smDown mdDown>
                    <Typography className={classes.secondtext}>
                      {lang.MEAsubtitle}
                    </Typography>

                    <Button
                      className={classes.getstart}
                      onClick={() => {
                        history.push("/app");
                      }}
                    >
                      {lang.Getstart}
                    </Button>
                  </Hidden>
                </div>
              </div>

              <img
                alt="bgimage"
                src={require("../../images/graphic-icon/home_cover.png")}
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </div>
          </Paper>
        </Grid>
      </Grid>

      <Serviceslide />
      <OurApi />
      <GetStarted />
    </div>
  );
};

export default Home;
